import { parseQueryStatNumber } from "./queryBuilder";

const toNumber = (value, fallback = 0) => {
  const num = parseQueryStatNumber(value);
  return num == null ? fallback : num;
};

export const buildBattingBoxRows = (batters = []) =>
  batters.map((batter, index) => ({
    id: batter.playerId || batter.name || `batter-${index}`,
    playerId: batter.playerId,
    playerName: batter.name,
    position: batter.position || "–",
    atBats: toNumber(batter.atBats),
    runs: toNumber(batter.runs),
    hits: toNumber(batter.hits),
    homeRuns: toNumber(batter.homeRuns),
    rbi: toNumber(batter.rbi),
    baseOnBalls: toNumber(batter.baseOnBalls),
    strikeOuts: toNumber(batter.strikeOuts),
    avg: parseQueryStatNumber(batter.avg),
  }));

export const buildPitchingBoxRows = (pitchers = []) =>
  pitchers.map((pitcher, index) => ({
    id: pitcher.playerId || pitcher.name || `pitcher-${index}`,
    playerId: pitcher.playerId,
    playerName: pitcher.name,
    inningsPitched: parseQueryStatNumber(pitcher.inningsPitched),
    hits: toNumber(pitcher.hits),
    runs: toNumber(pitcher.runs),
    earnedRuns: toNumber(pitcher.earnedRuns),
    baseOnBalls: toNumber(pitcher.baseOnBalls),
    strikeOuts: toNumber(pitcher.strikeOuts),
    era: parseQueryStatNumber(pitcher.era),
    decision: pitcher.decision || "–",
  }));

const hasPitchingLineStats = (pitching = {}) => {
  const walks = pitching.baseOnBalls ?? pitching.walks;
  return (
    (pitching.inningsPitched != null && pitching.inningsPitched !== "") ||
    pitching.earnedRuns != null ||
    pitching.strikeOuts != null ||
    walks != null
  );
};

const formatCount = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? String(num) : "0";
};

/** Render 0 as "0 ER" / "0 BB"; do not drop falsy zeros. */
export const formatPitchingDecisionLine = (pitching = {}) => {
  if (!hasPitchingLineStats(pitching)) {
    return pitching.summary || "";
  }

  const walks = pitching.baseOnBalls ?? pitching.walks;
  const parts = [];
  if (pitching.inningsPitched != null && pitching.inningsPitched !== "") {
    parts.push(`${pitching.inningsPitched} IP`);
  }
  parts.push(`${formatCount(pitching.earnedRuns)} ER`);
  parts.push(`${formatCount(pitching.strikeOuts)} K`);
  parts.push(`${formatCount(walks)} BB`);
  return parts.join(", ");
};
